module.exports = __webpack_public_path__ + "img/班鲁生产3.b6c5f80b.png";